import React from 'react'

function ApiDocsTab() {
  return (
    <div>ApiDocsTab</div>
  )
}

export default ApiDocsTab